import { useState } from "react";
import { motion } from "framer-motion";
import { CalendarDays, Sparkles } from "lucide-react";

const PHOTO = "/images/jay-kim.jpg";

export default function WorkshopPoster() {
  const [imgError, setImgError] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="relative overflow-hidden rounded-2xl border border-white/15 bg-panel shadow-[0_0_70px_rgba(255,0,122,0.25)]"
      data-testid="workshop-poster"
    >
      <div className="pointer-events-none absolute inset-0 z-10 bg-[radial-gradient(circle_at_75%_30%,rgba(255,0,122,0.28)_0%,transparent_55%)]" />
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="relative z-20 flex flex-col justify-between gap-8 p-7 sm:p-10">
          <div>
            <p className="mb-4 flex items-center gap-2 font-mono text-[11px] font-bold uppercase tracking-[0.3em] text-accent">
              <Sparkles size={13} /> K-House Dance Academy presenta
            </p>
            <h1 className="font-display font-black uppercase leading-[0.95] tracking-tight">
              <span className="block overflow-hidden text-[clamp(1.5rem,3.2vw,2.4rem)] text-white">
                <motion.span className="block" initial={{ y: "110%" }} animate={{ y: 0 }} transition={{ duration: 0.8, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}>
                  Special K-Pop
                </motion.span>
              </span>
              <span className="block overflow-hidden text-[clamp(1.5rem,3.2vw,2.4rem)] text-white">
                <motion.span className="block" initial={{ y: "110%" }} animate={{ y: 0 }} transition={{ duration: 0.8, delay: 0.28, ease: [0.16, 1, 0.3, 1] }}>
                  Dance Workshop
                </motion.span>
              </span>
              <span className="block overflow-hidden">
                <motion.span
                  className="block text-[clamp(3.4rem,8vw,7rem)] text-accent drop-shadow-[0_0_35px_rgba(255,0,122,0.55)]"
                  initial={{ y: "110%" }}
                  animate={{ y: 0 }}
                  transition={{ duration: 0.9, delay: 0.42, ease: [0.16, 1, 0.3, 1] }}
                >
                  Jay Kim
                </motion.span>
              </span>
            </h1>
            <p className="mt-5 max-w-sm font-mono text-[11px] font-bold uppercase leading-relaxed tracking-[0.2em] text-zinc-400">
              Ex-1MILLION Dance Studio
              <br />
              Coreógrafo de Jay Park &amp; THE BOYZ
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-3">
            <span className="flex items-center gap-2 rounded-full bg-accent px-5 py-2.5 font-display text-sm font-extrabold uppercase tracking-wide text-white shadow-[0_0_25px_rgba(255,0,122,0.5)]">
              <CalendarDays size={15} /> 21 · Nov · 2026
            </span>
            <span className="rounded-full border border-white/20 px-4 py-2 font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-zinc-300">
              Workshop internacional
            </span>
          </div>
        </div>

        <div className="relative min-h-[380px] lg:min-h-[560px]">
          {!imgError ? (
            <img
              src={PHOTO}
              alt="JAY KIM — artista invitado del Special K-Pop Dance Workshop"
              onError={() => setImgError(true)}
              className="absolute inset-0 h-full w-full object-cover object-top"
              loading="eager"
            />
          ) : (
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 border-l border-white/10 bg-[#0D0D12] text-center">
              <img src="/logo-mark.webp" alt="K-House" className="h-24 w-auto opacity-70" />
              <p className="max-w-[220px] font-mono text-[11px] font-bold uppercase leading-relaxed tracking-[0.25em] text-zinc-500">
                Foto oficial de Jay Kim pendiente de publicación
              </p>
            </div>
          )}
          <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(90deg,#08080A_0%,transparent_30%),linear-gradient(0deg,rgba(8,8,10,0.9)_0%,transparent_40%)]" />
        </div>
      </div>
    </motion.div>
  );
}
